import { useSyncExternalStore } from 'react';
import { Banner, InlineAction } from './ui.tsx';
import { staleBuildNoticeShown, subscribeStaleBuild } from './lib/stale-build.ts';

/**
 * The honest fallback when the stale-build guard (lib/stale-build.ts) will not
 * reload by itself — it already reloaded a moment ago, or the operator is
 * mid-task. Fixed above everything, including the full-bleed map, because the
 * part of the page that failed to load may be the part they are looking at.
 * Polite, not assertive: it is a notice, not an emergency.
 */
export function StaleBuildNotice() {
  const shown = useSyncExternalStore(subscribeStaleBuild, staleBuildNoticeShown);
  if (!shown) return null;
  return (
    <div role="status" className="fixed inset-x-0 top-0 z-[1000]">
      <Banner action={<InlineAction onClick={() => window.location.reload()}>Reload</InlineAction>}>
        A new version of EVAC is available. Part of this page could not load until you reload —
        finish what you are doing first.
      </Banner>
    </div>
  );
}
